import { useDispatch } from 'react-redux';

import store from 'src/store';

export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
